type CamelCaseUrlFields = {
  longUrls?: string[] | null
  longUrl?: string | null
}

type CamelCaseHardUrlFields = {
  longUrls?: string[] | null
  longUrl?: string | null
}

type LongUrlUnifiedModel = { longUrls: string[] }

function isNonEmptyLongUrl(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}

export function normalizeLongUrls(value?: string[] | null): string[] {
  return Array.isArray(value) ? value.filter(isNonEmptyLongUrl).map(url => url.trim()) : []
}

// overloads
export function longUrlApiToModel<T extends CamelCaseUrlFields>(api: T): Omit<T, 'longUrl'> & LongUrlUnifiedModel
export function longUrlApiToModel<T extends CamelCaseHardUrlFields>(
  api: T
): Omit<T, 'longUrl' | 'longUrls'> & LongUrlUnifiedModel

export function longUrlApiToModel(api: CamelCaseUrlFields | CamelCaseHardUrlFields): LongUrlUnifiedModel {
  const { longUrls, longUrl, ...rest } = api
  const normalizedLongUrls = normalizeLongUrls(longUrls)
  const normalizedLegacyLongUrl = isNonEmptyLongUrl(longUrl) ? [longUrl.trim()] : []

  return {
    ...rest,
    longUrls: normalizedLongUrls.length > 0 ? normalizedLongUrls : normalizedLegacyLongUrl
  }
}
